module.exports = __webpack_public_path__ + "7ccf762761f6430335969edada673da9.svg";